export default __webpack_public_path__ + "static/media/logo_white.cb516dbc.png";